import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ProjectOverview from './components/ProjectOverview';
import ProjectGoals from './components/ProjectGoals';
import EUProgramSection from './components/EUProgramSection';
import ProjectTimeline from './components/ProjectTimeline';

const AboutProject = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>About Project - Creative Twinning | Kreativna Saradnja</title>
        <meta 
          name="description" 
          content="Learn about the Creative Twinning cross-border tourism initiative connecting Serbia and Montenegro through heritage trails, cultural preservation, and sustainable tourism development." 
        />
        <meta name="keywords" content="Creative Twinning, heritage tourism, Serbia Montenegro, cross-border cooperation, EU project, cultural preservation" />
      </Helmet>

      <Header />
      
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-primary text-primary-foreground py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl mb-6">
                About Creative Twinning
              </h1>
              <p className="text-xl md:text-2xl text-primary-foreground/90 max-w-3xl mx-auto leading-relaxed">
                Connecting cultures, preserving heritage, and fostering sustainable tourism 
                across the beautiful landscapes of Serbia and Montenegro
              </p>
              <div className="mt-8 text-sm text-primary-foreground/80">
                <p>Kreativna Saradnja • Cross-Border Heritage Initiative • EU Funded Project</p>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <ProjectOverview />
            <ProjectGoals />
            <EUProgramSection />
            <ProjectTimeline />
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutProject;